// extracted by mini-css-extract-plugin
export default {"ingridiants_container":"Ingridiants_ingridiants_container__ti-kF"};